import React from 'react';
import './InputField.scss';
import FormattedText, { IFormattedText } from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  name?: string;
  value: any;
  type: 'email' | 'text' | 'number' | 'password';
  label?: IFormattedText;
  required: boolean;
  minLength?: number;
  disabled?: boolean;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FormEvent<HTMLInputElement>) => void;
}

const InputField: React.SFC<IProps> = ({
  name,
  type,
  value,
  label,
  required = false,
  minLength = 0,
  disabled = false,
  onChange,
  onBlur,
  children,
}) => {

  return (
    <div className='input-field'>
      { label && 
        <FormattedText 
          style='medium-bold'
          { ...label } 
        /> 
      }
      { label && !required && 
        <FormattedText
          displayName=' (valfri) '
          formattedName='global.optional'
        />
      }
      <input
        type={ type } 
        name={ name }
        value={ value ? value : '' }
        onChange={ onChange } 
        onBlur={ onBlur }
        required={ required }
        disabled={ disabled }
        minLength={ minLength }
      />
      { children }
    </div>
  );
};

export default InputField;


// WEBPACK FOOTER //
// ./src/components/Shared/InputField/InputField.tsx